module.exports = __webpack_public_path__ + "img/8.668f578a.jpeg";